export default (func, time = 1000, immediate = true) => {
  let timeout = !immediate

  return (...args) => {
    const callNow = !timeout
    const later = () => {
      timeout = !immediate
      func.apply(null, args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, time)

    if (callNow) func.apply(null, args)
  }
}



// WEBPACK FOOTER //
// ./src/lib/debounce.js